import ErrorUnauthorised from './errorUnauthorised'

export default ErrorUnauthorised
